import React from 'react';
import { Grid, Container } from '@material-ui/core';
import styles from './style.module.scss';
import HeadlineSmall from '../HeadlineSmall';
import HeadlineLarge from '../HeadlineLarge';
import DefaultContainer from '../DefaultContainer';
import MemberProfileCard from '../MemberProfileCard';
import ImageContainer from '../ImageContainer';

import { wearePage } from '../../data';
import teamAssets from '../../data/team';

const TeamSection = () => (
  <DefaultContainer
    justify="flex-start"
    direction="column"
    className={styles.container}
    noPadding
  >
    <Container>
      <Grid item>
        <HeadlineSmall>
          {wearePage.teamMemberHeadlineSmall}
        </HeadlineSmall>
        <HeadlineLarge
          stroke="team"
          lineBreak
          className={styles.headlineLarge}
          medium
        >
          {wearePage.teamMemberHeadlineLarge}
        </HeadlineLarge>
      </Grid>
    </Container>
    <ImageContainer spacing={4}>
      {teamAssets.map(item => (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          key={item.source.fall}
        >
          <MemberProfileCard {...item} />
        </Grid>
      ))}
    </ImageContainer>
  </DefaultContainer>
);

export default TeamSection;
